import { h } from 'preact'
import classnames from 'classnames'

interface Props {
  onPress: () => void
  disabled?: boolean
}

export function NextMonthButton({ onPress, disabled = false }: Props) {
  return (
    <button
      disabled={disabled}
      onClick={onPress}
      type="button"
      class="btn-icon-ghost"
    >
      <svg
        class="inline-flex w-5 h-5"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M9 5l7 7-7 7"
        />
      </svg>
    </button>
  )
}
